import './MentionLegales.scss';

export default function MentionsLegales() {
  return (
    <div className="legal">
      <h1>Mentions légales</h1>
      <h2>Éditeur du site</h2>
      <p>Nouhayla Er-raysy - Web </p>
      <p>Forme juridique : Entreprise individuelle</p> 
      <p>Email : Nouhaylaerrayssy99@gmail.com</p>
      <p>Téléphone : 07 58 80 48 74</p>

      <h2>Propriété intellectuelle</h2>
      <p>Tous les contenus sont protégés...</p>

      <h2>Propriété intellectuelle</h2>
      <p>
        Tous les contenus présents sur ce site, y compris les textes, images, logos, graphiques, vidéos et autres éléments,
        sont la propriété de Nouhayla Er-raysy ou de leurs propriétaires respectifs.
        Toute reproduction, représentation, modification ou diffusion de ces contenus,
        sans autorisation préalable écrite, est interdite.
      </p>

      <h2>Protection des données personnelles</h2>
      <p>
        Nouhayla Er-raysys’engage à respecter la confidentialité des données personnelles collectées via le site.
        Pour plus d’informations, veuillez consulter la politique de confidentialité.
      </p>
       <h2>Responsabilité</h2>
      <p>
        Nouhayla Er-raysy s’efforce d’assurer l’exactitude des informations présentes sur ce site.
        Toutefois, aucune garantie n’est donnée quant à leur exhaustivité ou leur mise à jour.
        L’utilisateur reconnaît utiliser ces informations sous sa responsabilité exclusive.
      </p>

      <h2>Loi applicable</h2>
      <p>
        Les présentes mentions légales sont régies par la loi française.
        En cas de litige, les tribunaux compétents seront ceux du ressort de Valenciennes.
      </p>

      <h2>Mise à jour</h2>
      <p>
        Les présentes mentions légales peuvent être modifiées à tout moment afin de rester conformes à la réglementation.
        Il est conseillé aux utilisateurs de les consulter régulièrement.
      </p>
    </div>
  );
}